<template>
    <div>
        <a-modal v-model="visible" title="分类设置" :width="800" centered :footer="false">
            <a-space direction="vertical">
                <a-row :gutter="12" type="flex" align="middle" justify="space-between">
                    <a-col :span="12">
                        <choose-organ v-model="organId" @change="getList()"></choose-organ>
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="$refs.formRef.show()" icon="plus">添加分类</a-button>
                    </a-col>
                </a-row>
                <a-table :loading="loading" :data-source="list" :columns="keys" rowKey="cateId" size="small">
                    <template slot-scope="row" slot="sort">
                        <a-input-number v-model="row.sort" @pressEnter="setSort(row)"></a-input-number>
                    </template>
                    <template slot-scope="row" slot="state">
                        <a-tag color="green" v-if="row.state">启用</a-tag>
                        <a-tag color="red" v-else>停用</a-tag>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="编辑" v-has="'grade-mall:category:save'">
                                <a-button type="primary" @click="$refs.formRef.show(row)" icon="edit"></a-button>
                            </a-tooltip>
                            <a-tooltip title="删除" v-has="'grade-mall:category:delete'">
                                <a-button type="danger" @click="del(row.cateId)" icon="delete"></a-button>
                            </a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-space>

        </a-modal>
        <goods-cate-form ref="formRef" @success="getList()"></goods-cate-form>
    </div>
</template>

<script>
import utils from '@/common/utils';
import request from '@/config/request';
import goodsCateForm from './goods-cate-form.vue'
import apiUtils from '@/common/apiUtil';
export default {
    components: { goodsCateForm },
    data() {
        return {
            visible: false,
            loading: false,
            keys: [
                { title: '名称', dataIndex: 'name', width: 160, ellipsis: true },
                { title: '排序', scopedSlots: { customRender: 'sort' }, align: 'center', width: 200 },
                { title: '状态', scopedSlots: { customRender: 'state' }, align: 'center', width: 100 },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 100 }
            ],
            list: [],
            organId: apiUtils.getDefaultOrganId()
        }
    },
    methods: {
        //获取列表数据
        getList() {
            this.loading = true;
            utils.loading();
            request.get('/platform/grade-mall/category/list', { organId: this.organId }).then(ret => {
                this.list = ret.data;
                this.visible = true;
            }).finally(() => {
                this.loading = false;
            })
        },
        setSort(row) {
            this.loading = true;
            request.post('/platform/grade-mall/category/save', row).then(ret => {
                this.getList();
            }).finally(() => {
                this.loading = false;
            })
        },
        del(rowId) {
            utils.confirm('确定删除该分类？').then(() => {
                this.loading = true;
                request.delete('/platform/grade-mall/category/delete/' + rowId).then(ret => {
                    utils.success('删除成功');
                    this.getList();
                }).finally(() => {
                    this.loading = false;
                })
            })
        },
        show() {
            this.getList();
        }
    },
    watch: {
        visible(val) {
            if (!val) {
                this.$emit('close')
            }
        }
    }
}
</script>

<style></style>